import { Col, Row } from 'antd';
import { ColProps } from 'antd/es/grid';
import styled, { css, keyframes } from 'styled-components';
import { Keyframes } from 'styled-components/dist/types';

import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';
import { TileContainer } from '~src/styles/containers.sc';

export const FormContainer = styled.div`
  display: flex;
  overflow: hidden;
`;

const movingIn = keyframes`
  from {
    margin-right: -1000px;
  }
`;

const movingOut = keyframes`
  to {
    margin-right: -1000px;
  }
`;

const getAnimation = (status: string): Keyframes | 'none' => {
  if (status === 'entering') {
    return movingIn;
  } else if (status === 'exiting') {
    return movingOut;
  }
  return 'none';
};

interface TransitionContainer {
  $duration: number;
  $toggled: boolean;
  $leftColSize?: number;
}

export const DefaultContainer = styled.div<TransitionContainer>`
  width: ${({ $toggled, $leftColSize }) => (!$toggled ? 100 : $leftColSize ? ($leftColSize / 24) * 100 : 50)}%;
  padding: 0 15px;
  transition: all ${({ $duration }) => $duration}ms cubic-bezier(0.73, 0.01, 0, 1);
`;

export const TranslationContainer = styled.div<TransitionContainer & { $status: string }>`
  animation: ${({ $status, $duration }) =>
      css`
        ${getAnimation($status)} ${$duration}ms
      `}
    cubic-bezier(0.73, 0.01, 0, 1);
  margin-right: ${({ $toggled, $status }) => ($toggled || $status === 'entering' ? '0' : '-1000px')};
  width: ${({ $leftColSize }) => ($leftColSize ? ((24 - $leftColSize) / 24) * 100 : 50)}%;
  padding: 0 15px;
  border-left: 1px solid ${({ theme }) => theme.black.a1};
`;

export const TileContainerS = styled(TileContainer)`
  &.no-title {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const FormContent = styled.div<{ $inContainer?: boolean }>`
  padding: ${({ $inContainer }) => $inContainer && '30px 30px 20px'};
`;

export const DefLangTitle = styled.span.attrs({ className: 'caption_text' })`
  text-transform: uppercase;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin: 0;
`;

export const DefLangTxt = styled.div`
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const LeftColHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  height: 60px;
`;

export const ToggleTranslationBtn = styled.a.attrs({ className: 'caption_text' })`
  color: ${({ theme }) => theme.baseBlue.a6};
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
`;

export const Fieldset = styled.fieldset<{ $isCustomScaleForm?: boolean }>`
  border: 0;
  padding: 0;
  margin: 34px 0 0;
  ${({ $isCustomScaleForm }) =>
    $isCustomScaleForm &&
    `
    margin: 14px 0 0;
  `}
`;

export const RightCol = styled(Col)<ColProps>`
  border-left: 1px solid ${({ theme }) => theme.black.a1};
  ${Fieldset} {
    margin-top: 20px;
  }
`;

export const ContentLocaleSelectBox = styled.div`
  width: 200px;
  height: 60px;
`;

export const CancelBtn = styled(SecondaryButton)``;

export const SubmitBtn = styled(PrimaryButtonLoading)`
  margin-left: 15px;
`;

export const ButtonsPanel = styled.div`
  min-height: 45px;
  display: flex;
  justify-content: flex-end;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RowStyled = styled(Row).attrs({ gutter: 30 })`
  padding-left: 15px;
`;

export const CheckboxWrapper = styled.div`
  padding: 1rem 0rem;
`